import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
  const data = _tagged_template_literal(["\n	display: flex;\n	justify-content: center;\n	align-items: center;\n	transition: all 0.2s ease;\n	border-radius: ", ";\n	cursor: pointer;\n	&:hover {\n		background-color: ", " !important;\n	}\n"]);
  _templateObject = function () {
    return data;
  };
  return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { NewBaseIcon } from "../NewBaseIcon";
import styled from "styled-components";
export const TransparentIconButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    icon,
    size = 32,
    iconSize = 20,
    shape = "round",
    className,
    style,
    iconColor,
    onClick,
    hoverBgColor = "rgba(242, 244, 247, 1)"
  } = props;
  const borderRadius = {
    circle: "50%",
    round: "4px",
    square: "0"
  };
  return /*#__PURE__*/_jsx(TransparentIconButtonCss, {
    style: {
      hoverBgColor: hoverBgColor,
      borderRadius: borderRadius[shape],
      height: size,
      width: size,
      ...style
    },
    className: className,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(NewBaseIcon, {
      size: iconSize,
      icon: icon,
      color: iconColor
    })
  });
});
const TransparentIconButtonCss = styled.div(_templateObject(), props => props.style.borderRadius, props => props.style.hoverBgColor);